import { Box, Button } from '@mui/material'

import { carouselItemSx, itemImageSx } from './styles'

import { Carousel } from '../Carousel'

export interface AsSeenInItem {
  image: {
    name: string
    src: string
  }
  link?: string
}

const SIZE_OF_ITEMS_PER_WINDOW_BREAKPOINT_IN_PX = {
  xs: 130,
  md: 155,
  lg: 180,
  xl: 190,
  xxl: 190,
}

const AS_SEEN_IN_CAROUSEL_ITEMS: AsSeenInItem[] = [
  {
    image: {
      name: 'Medium',
      src: '/images/landing-pages/as-seen-in/medium.webp',
    },
    link: 'https://amirbakian.medium.com/shattering-the-status-quo-how-the-launchpad-is-overhauling-traditional-it-lead-generation-f8dbb592210c',
  },
  {
    image: {
      name: 'LA Weekly',
      src: '/images/landing-pages/as-seen-in/la-weekly.webp',
    },
    link: 'https://www.laweekly.com/revolutionizing-tech-sales-the-launchpads-innovative-matchmaking-platform-changes-the-game/',
  },
  {
    image: {
      name: 'Entrepreneur',
      src: '/images/landing-pages/as-seen-in/entrepreneur.webp',
    },
    link: 'https://www.entrepreneur.com/en-in/entrepreneurs/top-entrepreneurs-changing-the-world-from-realtors-to/432791',
  },
  {
    image: {
      name: 'Disrupt',
      src: '/images/landing-pages/as-seen-in/disrupt.webp',
    },
    link: 'https://disruptmagazine.com/the-end-of-cold-calls-how-tonya-turrell-and-the-launchpad-have-become-the-best-resource-for-it-solutions/',
  },
  {
    image: {
      name: 'The Daily Scanner',
      src: '/images/landing-pages/as-seen-in/the-daily-scanner.webp',
    },
    link: 'https://www.dailyscanner.com/meet-the-visionary-founder-of-the-launchpad-transforming-the-tech-industry-with-groundbreaking-matchmaking-solutions/',
  },
  {
    image: {
      name: 'UBJ',
      src: '/images/landing-pages/as-seen-in/ubj.webp',
    },
    link: 'https://theubj.com/featured/124236/the-launchpad-breaks-new-ground-in-tech-by-playing-matchmaker-for-vendors-it-buyers/',
  },
  {
    image: {
      name: 'USA Today',
      src: '/images/landing-pages/as-seen-in/usa-today.webp',
    },
    link: 'https://www.usatoday.com/story/sponsor-story/level-up/2022/06/07/meet-startup-founders-changing-their-industries/7468437001/',
  },
  {
    image: {
      name: 'America Daily Post',
      src: '/images/landing-pages/as-seen-in/america-daily-post.webp',
    },
    link: 'https://www.americadailypost.com/tonya-turrell-on-the-success-of-the-launchpad-and-what-matters-most-in-business/',
  },
  {
    image: {
      name: 'New York Weekly',
      src: '/images/landing-pages/as-seen-in/new-york-weekly.webp',
    },
    link: 'https://nyweekly.com/tech/the-launchpad-is-leading-the-tech-industry-with-innovative-matchmaking-services/',
  },
  {
    image: {
      name: 'Yahoo Finance',
      src: '/images/landing-pages/as-seen-in/yahoo-finance.webp',
    },
    link: 'https://finance.yahoo.com/news/launchpad-ignites-technology-matchmaking-mql-064500077.html',
  },
  {
    image: {
      name: 'Venture Capital Post',
      src: '/images/landing-pages/as-seen-in/venture-capital-post.webp',
    },
    link: 'https://www.vcpost.com/articles/123890/20220812/the-demand-generation-era-is-over-%E2%80%94-how-the-launchpad-mql-membership-program-meets-the-it-needs-of-the-revenue-era.htm',
  },
  {
    image: {
      name: 'Orlando City Magazine',
      src: '/images/landing-pages/as-seen-in/orlando-city-magazine.webp',
    },
    link: 'https://www.orlandomagazine.com/orlandos-2022-women-of-the-year/',
  },
  {
    image: {
      name: 'Digital Journal',
      src: '/images/landing-pages/as-seen-in/digital-journal.webp',
    },
    link: 'https://www.digitaljournal.com/business/gen-z-and-millennials-drive-transformation-in-it-lead-generation-tonya-turrell-delivers-bold-response-with-the-launchpad/article',
  },
]

const AsSeenInCarousel = () => (
  <Carousel
    id="as-seen-in-carousel"
    dontCenterWhenFewerItems
    items={AS_SEEN_IN_CAROUSEL_ITEMS}
    numberOfItemsPerPage={{
      dynamic: true,
      size: SIZE_OF_ITEMS_PER_WINDOW_BREAKPOINT_IN_PX,
    }}
    renderItem={({ image, link }, key) => (
      <Button
        key={key}
        data-testid="carousel-item"
        component="a"
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        sx={carouselItemSx({
          pointerCursor: !!link,
        })}
      >
        <Box
          alt={image.name}
          title={image.name}
          loading="lazy"
          component="img"
          src={image.src}
          sx={itemImageSx}
        />
      </Button>
    )}
  />
)

export { AsSeenInCarousel }
